import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class JsonDateService {
  private _isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z$/;

  protected isIsoDateString(value: unknown): boolean {
    if (value === null && value === undefined) return false;
    if (typeof value !== 'string') return false;
    return this._isoDateFormat.test(value);
  }

  /**
   * Finds and converts ISOString dates into real Date instances. Inplace!
   * @param body the object to convert in-place
   */
  public convert<T>(body: T): T {
    if (body === null || body === undefined || typeof body !== 'object') {
      return body;
    }
    const assertedBody = body as Record<string, unknown>;
    for (const key of Object.keys(assertedBody)) {
      const value = assertedBody[key];
      if (this.isIsoDateString(value)) {
        assertedBody[key] = new Date(value as string);
      } else if (typeof value === 'object') {
        this.convert(value);
      }
    }
    return body;
  }
}
